import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import { getMUICache, } from '../../../common/utils';
import './PageNotFoundTwo.css';

PageNotFoundTwo.version = 1000;

PageNotFoundTwo.lang = 'en';
PageNotFoundTwo.langs = [
    'en'
];
PageNotFoundTwo.setLang = (lang: any) => {
    PageNotFoundTwo.lang = lang;
}

Object.defineProperty(PageNotFoundTwo, 'name', {
  writable: true,
  value: 'PageNotFoundTwo'
});

export function PageNotFoundTwo(props: any) {
    const cache = getMUICache();

    return (
        <CacheProvider value={cache}>
                <Grid item md={12} xs={12}>
                    <div className='errorwrapper'>
                        <div className='erroeheading'>
                            <div className='errortext'>404</div>
                        </div>
                        <div className='errorcontent'>
                            <h3>Sorry, the content you’re looking for doesn’t exist. Either it was removed, or you mistyped the link.</h3>
                            
                        </div>
                    </div>
                </Grid>
        </CacheProvider>

    )

}
